import type { ComponentProps } from "react";

import { Cues } from "../cues";
import { AudioVisualiser } from "./audio-visualiser";
import styles from "./index.module.css";

interface ListenerModeProps extends Pick<
  ComponentProps<typeof Cues>,
  "pendingCues" | "onAcknowledge"
> {
  analyser: AnalyserNode | null;
}

export const ListenerMode = ({ analyser, pendingCues, onAcknowledge }: ListenerModeProps) => {
  return (
    <div className={styles.container}>
      <AudioVisualiser analyser={analyser} />
      <Cues pendingCues={pendingCues} onAcknowledge={onAcknowledge} />
    </div>
  );
};
